var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNetwork(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.36,
    height: 34.357,
    viewBox: "0 0 34.36 34.357",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "network",
    transform: "translate(-0.002 -0.021)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28806",
    "data-name": "Group 28806",
    transform: "translate(2.198 11.212)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28805",
    "data-name": "Group 28805"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39785",
    "data-name": "Path 39785",
    d: "M33.876,166.981l0,0a.671.671,0,0,0-.949.949l0,0a.671.671,0,1,0,.949-.949Z",
    transform: "translate(-32.725 -166.78)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_28808",
    "data-name": "Group 28808",
    transform: "translate(22.475 1.827)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28807",
    "data-name": "Group 28807"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39786",
    "data-name": "Path 39786",
    d: "M336.022,27.137a.671.671,0,0,0-.949.949l0,0a.669.669,0,0,0,.947,0A.674.674,0,0,0,336.022,27.137Z",
    transform: "translate(-334.876 -26.941)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_28810",
    "data-name": "Group 28810",
    transform: "translate(0.002 0.021)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28809",
    "data-name": "Group 28809",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39787",
    "data-name": "Path 39787",
    d: "M33.873,25a.671.671,0,0,0-1.247.5,5.5,5.5,0,0,1-.352,4.8,3.158,3.158,0,0,0-2.166-1.991l-.18-.048a2.8,2.8,0,0,0,.4-1.445v-.559a2.814,2.814,0,0,0-5.628,0v.559a2.8,2.8,0,0,0,.4,1.445l-.18.048a3.158,3.158,0,0,0-2.166,1.99,5.5,5.5,0,0,1,6.772-7.884.671.671,0,0,0,.49-1.249,6.86,6.86,0,0,0-8.2,2.568L15.7,20.458a8.233,8.233,0,0,0,0-6.511l6.125-3.275A6.844,6.844,0,1,0,24.976.509a.671.671,0,1,0,.5,1.247,5.5,5.5,0,0,1,6.8,7.873,3.158,3.158,0,0,0-2.166-1.99l-.18-.048a2.8,2.8,0,0,0,.4-1.445V5.588a2.814,2.814,0,1,0-5.628,0v.559a2.8,2.8,0,0,0,.4,1.445l-.18.048a3.158,3.158,0,0,0-2.166,1.99,5.506,5.506,0,0,1-.364-4.775.671.671,0,1,0-1.249-.49,6.846,6.846,0,0,0,.049,5.123l-6.125,3.275A8.19,8.19,0,0,0,4.306,9.991a.671.671,0,0,0,.637,1.182A6.846,6.846,0,0,1,14.186,20.5a3.907,3.907,0,0,0-2.675-2.448l-.506-.133a3.439,3.439,0,0,0,.642-2v-.727a3.459,3.459,0,0,0-6.918,0v.727a3.439,3.439,0,0,0,.642,2l-.506.134A3.907,3.907,0,0,0,2.193,20.5a6.892,6.892,0,0,1-.033-6.539A.671.671,0,1,0,.978,13.32a8.252,8.252,0,0,0-.9,5.016,8.188,8.188,0,0,0,14.988,3.305l6.121,3.273A6.847,6.847,0,1,0,33.873,25ZM26.044,5.588a1.472,1.472,0,1,1,2.943,0v.559a1.472,1.472,0,0,1-2.943,0Zm-2.13,5.242v-.14a1.815,1.815,0,0,1,1.351-1.753l1.009-.266a2.806,2.806,0,0,0,2.484,0l1.009.266a1.815,1.815,0,0,1,1.351,1.753v.332s0,0,0,0a5.5,5.5,0,0,1-7.227-.021A.663.663,0,0,0,23.914,10.83ZM6.071,15.189a2.117,2.117,0,0,1,4.234,0v.727a2.117,2.117,0,1,1-4.234,0v-.727Zm7.006,6.8-.049.05a6.853,6.853,0,0,1-9.68,0L3.3,21.991v-.163a2.564,2.564,0,0,1,1.908-2.477l1.387-.366a3.447,3.447,0,0,0,3.186,0l1.387.366a2.564,2.564,0,0,1,1.908,2.477Zm12.967,4.265a1.472,1.472,0,0,1,2.943,0v.559a1.472,1.472,0,0,1-2.943,0ZM23.89,31.674a.671.671,0,0,0,.024-.175v-.14a1.815,1.815,0,0,1,1.351-1.753l1.009-.266a2.806,2.806,0,0,0,2.484,0l1.009.266a1.815,1.815,0,0,1,1.351,1.753v.332s0,0,0,0A5.509,5.509,0,0,1,23.89,31.674Z",
    transform: "translate(-0.002 -0.021)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_28812",
    "data-name": "Group 28812",
    transform: "translate(31.21 22.496)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28811",
    "data-name": "Group 28811"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39788",
    "data-name": "Path 39788",
    d: "M466.19,335.128a.671.671,0,0,0-.949,0l0,0a.671.671,0,1,0,.953,0Z",
    transform: "translate(-465.041 -334.931)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetwork);
export default __webpack_public_path__ + "static/media/network.edcfb6cbbc00218a72971054d06d448e.svg";
export { ForwardRef as ReactComponent };